module.exports = __webpack_public_path__ + "868d7767171f655ce54b927a02ad95af.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-photo/img/small_255x255_icon.png
// module id = 761
// module chunks = 0